const searchInput = document.querySelector('.docs-search [type="search"]');
const resultsList = document.querySelector('.wp-block-docs-archive');
const searchLabel = document.querySelector('.docs-archive-list__header h3');
const initialItems = resultsList && resultsList.innerHTML;
const initialSearchLabel = searchLabel && searchLabel.innerText;

const showResults = async () => {
	const inputValue = searchInput.value;

	if (0 < inputValue.length) {
		// eslint-disable-next-line no-undef
		const url = `${PushengageSearch.search_endpoint}&per_page=24&search=${inputValue}&_wpnonce=${PushengageSearch.nonce}`;
		try {
			const response = await fetch(url);
			if (!response.ok) {
				resultsList.innerHTML =
					'<li>Uh Oh! An error was encountered. Please refresh the page and try again.</li>';
				return;
			}

			const docs = await response.json();
			if (docs.length) {
				resultsList.innerHTML = docs
					.map((doc) => {
						return `<li class="docs-cat__search-entry"><a href="${doc.url}">${doc.title}</a></li>`;
					})
					.join('');
			} else {
				resultsList.innerHTML = '<li>Sorry, no results were found!</li>';
			}
		} catch {
			resultsList.innerHTML = '<li>Uh Oh! An error was encountered. Please refresh the page and try again.</li>';
		}
	}
};

if (searchInput && resultsList && searchLabel) {
	let timeoutId;
	searchInput.oninput = function () {
		clearTimeout(timeoutId);
		const inputValue = searchInput.value;
		if (inputValue && inputValue.trim()) {
			searchLabel.innerText = `Searching for "${inputValue}"`;
			resultsList.classList?.add('loading');
			timeoutId = setTimeout(async () => {
				await showResults();
				resultsList.classList?.remove('loading');
			}, 400);
		} else {
			searchLabel.innerText = initialSearchLabel;
			resultsList.innerHTML = initialItems;
			resultsList.classList?.remove('loading');
		}
	};
}
